"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownIconMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _buttonResetMixin = require("../buttonResetMixin");
var _iconSizeMixin = require("../iconSizeMixin");
/** @class DropdownIconMixin */
/**
 * Standalone styles for the DropdownIcon component. Expects an Icon component as a child.
 *
 * @example
 * import { DropdownIconMixin, IconMore } from '@zillow/constellation';
 *
 * const Component = styled.button`
 *     ${DropdownIconMixin}
 * `;
 *
 * <Component>
 *     <IconMore />
 * </Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
var DropdownIconMixin = function DropdownIconMixin(props) {
  return (0, _styledToken.default)({
    iconColor: 'DropdownIcon.iconColor',
    iconSize: 'DropdownIcon.size'
  }, function (_ref) {
    var iconColor = _ref.iconColor,
      iconSize = _ref.iconSize;
    return (0, _styledComponents.css)(["", " ", " color:", ";"], (0, _buttonResetMixin.buttonResetMixin)(props), (0, _iconSizeMixin.iconSizeMixin)(Object.assign({}, props, {
      iconSize: iconSize
    })), iconColor);
  })(props);
};
exports.DropdownIconMixin = DropdownIconMixin;